import { useState } from "react";
import { Helmet } from "react-helmet";
import Ranking from "../../Components/Ranking";

const ICC_Rankings = () => {
  const [ranking, setRanking] = useState("Men");
  const tabs = ["Men", "Women"];

  return (
    <>
      <Helmet>
        <title>
          Match Rankings | Up-to-Date Sports Rankings at cricket betting tips
        </title>
        <meta
          name="description"
          content="Stay ahead with the latest match rankings at cricket betting tips. Get real-time updates, detailed insights, and expert analysis on your favorite teams and players."
        />
      </Helmet>

      <div className="ranking-tabs xl:w-[60%] lg:w-[80%] w-full mx-auto">
        <div className="pt-14 page-info-tabs flex space-x-2 lg:space-x-4 pb-4 border-b-2 border-[#dc9a2b12] mx-4 xl:mx-0">
          {tabs.map((tab) => (
            <span
              key={tab}
              onClick={() => setRanking(tab)}
              className={`px-6 py-2 rounded-[32px] cursor-pointer font-semibold transition
                ${
                  ranking === tab
                    ? "bg-[#DC9A2B] text-white"
                    : "bg-white text-black hover:bg-[#000000A3] hover:text-[#DC9A2B]"
                }`}
            >
              {tab}
            </span>
          ))}
        </div>
      </div>

      <Ranking RankingFor={ranking} />
    </>
  );
};

export default ICC_Rankings;
